import { CardFormFactor, checkCardType } from 'app/shared-components/cards/CardTypes';
import { HighnoteProductType } from 'API';

/**
 * Get card design for mobile carousel
 * @param productType - Credit or Debit
 * @param formFactor - Physical or Virtual
 * @param useMobileDesign - Whether to use your custom mobile design
 * @returns Card type information including background image
 */
export const getMobileCardDesign = (
  productType?: HighnoteProductType,
  formFactor?: CardFormFactor,
  useMobileDesign = true
) => {
  const variant = useMobileDesign ? 'mobile' : 'default';
  return checkCardType(productType, formFactor, variant);
};

/**
 * Example usage in your carousel:
 *
 * const cardType = getMobileCardDesign(
 *   integration?.highnoteProduct?.type,
 *   card.formFactor,
 *   true // Use your mobile design
 * );
 *
 * // Then use cardType.cardImage, cardType.textColor, etc.
 */
